import { switchCase } from '@main/utils';

/** Only render files smaller than this. This is in bytes */
export const MAX_FILE_SIZE_SINGLE = 358400; // 350kb

export const MAX_FILE_SIZE_SINGLE_HTML = 3670016; // 3.5mb
export const MAX_FILE_SIZE_MEDIA = 94371840; // 90mb

export const getMaxFileSizeFromMimetype = switchCase<number, [string], string>({
  video: MAX_FILE_SIZE_MEDIA,
  image: MAX_FILE_SIZE_MEDIA,
  text: (secondary) =>
    secondary === 'html' ? MAX_FILE_SIZE_SINGLE_HTML : MAX_FILE_SIZE_SINGLE,
  audio: MAX_FILE_SIZE_MEDIA,
})(MAX_FILE_SIZE_SINGLE);

/**
 * Check if a file is too big to render, based on it's size
 *
 * @param size - Size of file
 * @param mimetype - Mimetype of file
 * @returns True if can render
 */
export function isFileTooLargeToRender(
  size: number,
  mimetype: string,
): boolean {
  const [type, secondary] = (mimetype || '').split('/');
  const maxSize = getMaxFileSizeFromMimetype(type, secondary);
  return size >= maxSize;
}
